<form
	class="zk-flex zk-flex-wrap sm:zk--mx-3"
	(ngSubmit)="save($event)"
	[formGroup]="form"
>
	<div class="zk-w-full xl:zk-w-5/12 lg:zk-px-2">
		<h1 class="zk-text-base zk-font-thick zk-mb-4">
			{{ 'MY_ACCOUNT.PERSONAL.AVATAR.TITLE' | translate }}
		</h1>
		<p
			class="zk-text-sm zk-mb-8"
			[innerHTML]="'MY_ACCOUNT.PERSONAL.AVATAR.DESCRIPTION' | translate"
		></p>

		<div class="zk-mb-10">
			<zk-avatar-cropper
				class="zk-flex zk-justify-center"
				[picture]="form.get('imageUrl').value || null"
				[fullName]="form.get('name').value"
				[minHeight]="299"
				[minWidth]="299"
				[status]="getStatus('imageUrl')"
				(cropped)="imageUrlChange($event)"
				(error)="handleImageUrlError($event)"
			></zk-avatar-cropper>

			<div
				*ngIf="getStatus('imageUrl') === 'error'"
				class="zk-text-error zk-text-xs zk-text-center zk-mt-4 zk-px-4"
			>
				{{ getErrorMessage('imageUrl') }}
			</div>
		</div>
	</div>

	<div class="zk-w-full xl:zk-w-7/12 xl:zk-pl-8 lg:zk-px-2">
		<h1 class="zk-text-base zk-font-thick zk-mb-6">
			{{ 'MY_ACCOUNT.PERSONAL.BASIC_INFO' | translate }}
		</h1>

		<div class="zk-flex zk-flex-col md:zk-grid zk-grid-cols-2 zk-gap-4">
			<zk-input [zkStatus]="getStatus('name')" class="md:zk-col-span-2">
				<input zkInputRef formControlName="name" placeholder=" " />
				<span zkInputLabel>{{ 'MY_ACCOUNT.PERSONAL.NAME' | translate }}</span>
				<span zkInputMessage class="zk--mt-2">
					{{ getErrorMessage('name') }}
				</span>
			</zk-input>

			<div>
				<zk-input-phone
					formControlName="phone"
					[label]="'MY_ACCOUNT.PERSONAL.MOBILEPHONE' | translate"
					[class.has-value]="form.get('phone')?.value"
					[status]="getStatus('phone')"
					[message]="getErrorMessage('phone')"
				></zk-input-phone>
				<div
					*ngIf="getStatus('phone') === 'default'"
					class="zk-text-xs md:zk-text-right zk-mt-1 zk-text-grey zk-pl-4"
				>
					{{ 'MY_ACCOUNT.PERSONAL.HIDDEN_TO_CUSTOMER' | translate }}
				</div>
			</div>

			<div class="birthday__wrapper">
				<label>{{ 'PAGES.ACCOUNT.FORM.BIRTHDAY' | translate }}</label>
				<p-calendar
					[monthNavigator]="true"
					[yearNavigator]="true"
					[yearRange]="getBirthDateRange()"
					class="p-calendar-in-form"
					dateFormat="dd/mm/yy"
					formControlName="birthDate"
					inputStyleClass="{{
						'input zk-rounded-sm zk-text-sm ' +
							(getStatus('birthDate') === 'error'
								? 'zk-border-error zk-shadow-outline-error zk-text-error'
								: 'zk-border-grey-light')
					}}"
					[placeholder]="'MY_ACCOUNT.PERSONAL.BIRTH_DATE' | translate"
					selectionMode="single"
					styleClass="box"
				></p-calendar>

				<div
					class="zk-text-xs md:zk-text-right zk-mt-1"
					[ngClass]="{
						'zk-text-grey md:zk-text-right zk-pl-4':
							getStatus('birthDate') === 'default',
						'zk-text-error zk-px-4': getStatus('birthDate') === 'error'
					}"
				>
					{{
						getStatus('birthDate') === 'error'
							? getErrorMessage('birthDate')
							: ('MY_ACCOUNT.PERSONAL.HIDDEN_TO_CUSTOMER' | translate)
					}}
				</div>
			</div>

			<div>
				<zk-dropdown
					formControlName="gender"
					[label]="'MY_ACCOUNT.PERSONAL.GENDER' | translate"
					[options]="gender"
					[zkStatus]="getStatus('gender')"
				></zk-dropdown>

				<div
					*ngIf="getStatus('gender') === 'error'"
					class="zk-text-error zk-text-xs zk-mt-1 zk-px-4"
				>
					{{ getErrorMessage('gender') }}
				</div>
			</div>

			<div>
				<zk-dropdown
					formControlName="ethnicity"
					[label]="'MY_ACCOUNT.PERSONAL.ETHNICITY' | translate"
					[options]="ethnicity"
					[zkStatus]="getStatus('ethnicity')"
				></zk-dropdown>

				<div
					class="zk-text-xs zk-mt-1 zk-pl-4"
					[ngClass]="{
						'zk-text-grey md:zk-text-right':
							getStatus('ethnicity') === 'default',
						'zk-text-error zk-px-4': getStatus('ethnicity') === 'error'
					}"
				>
					<div
						*ngIf="getStatus('ethnicity') !== 'error'; else elseDefault"
						[innerHTML]="'MY_ACCOUNT.PERSONAL.ETHNICITY_MESSAGE' | translate"
					></div>
					<ng-template #elseDefault>
						{{ getErrorMessage('ethnicity') }}
					</ng-template>
				</div>
			</div>

			<div class="zk-col-span-2 zk-flex zk-items-center zk-gap-1 lgbt-checkbox-wrapper">
				<freud-checkbox
					[formControl]="form.controls.isLgbt"
					formControlName="isLgbt"
					[label]="'MY_ACCOUNT.PERSONAL.LGBT_CHECKBOX' | translate"
				>
				</freud-checkbox>
				<span class="icon-wrapper" freud-tooltip [tooltipLabel]="'MY_ACCOUNT.PERSONAL.LGBT_TOOLTIP' | translate" tooltipPosition="bottom">
					<freud-icon icon="info-circle" size="sm"></freud-icon>
				</span>
			</div>

			<div class="md:zk-col-span-2">
				<zk-dropdown
					formControlName="location"
					class="md:zk-col-span-2"
					[label]="'MY_ACCOUNT.PERSONAL.LOCATION' | translate"
					[zkStatus]="getStatus('location')"
					[options]="location"
				></zk-dropdown>
				<div
					*ngIf="getStatus('location') === 'error'"
					class="zk-text-error zk-text-xs zk-mt-1 zk-px-4"
				>
					{{ getErrorMessage('location') }}
				</div>
			</div>

			<zk-tooltip
				theme="default"
				class="md:zk-col-span-2"
				tooltipMessage="{{
					'MY_ACCOUNT.PERSONAL.TOOLTIP_CANT_EDIT' | translate
				}}"
			>
				<div class="zk-w-full">
					<zk-input [disabled]="true" class="md:zk-col-span-2">
						<input zkInputRef type="email" [value]="user?.email" />
						<span zkInputLabel>{{
							'MY_ACCOUNT.PERSONAL.EMAIL' | translate
						}}</span>
					</zk-input>
				</div>
			</zk-tooltip>

			<div class="zk-col-span-2 zk-flex zk-justify-between">
				<zk-input [disabled]="true" class="input-password">
					<input zkInputRef type="password" value="******" />
					<span zkInputLabel>{{
						'MY_ACCOUNT.PERSONAL.PASSWORD' | translate
					}}</span>
				</zk-input>
				<button
					zkAnchor
					type="button"
					class="zk-mt-2 btn-change-password"
					(click)="showChangePasswordDialog = true"
				>
					{{ 'MY_ACCOUNT.PERSONAL.CHANGE_PASSWORD' | translate }}
				</button>
			</div>

			<div class="zk-col-span-2 md:zk-text-right zk-mt-12">
				<button
					zk-button
					[zkButtonLoading]="isLoading"
					class="button-save"
					type="submit"
					[disabled]="!form.dirty"
				>
					{{ 'MY_ACCOUNT.PERSONAL.SAVE' | translate }}
				</button>
			</div>
		</div>
	</div>
</form>

<zk-dialog [(isOpen)]="showChangePasswordDialog">
	<ng-container zk-dialog-header>
		{{ 'MY_ACCOUNT.PERSONAL.CHANGE_PASSWORD' | translate }}
	</ng-container>
	<ng-container zk-dialog-body>
		<app-change-password-form
			[user]="user"
			[(save)]="saveNewPassword"
			(saved)="passwordChanged()"
		></app-change-password-form>
	</ng-container>
	<ng-container zk-dialog-footer>
		<div class="zk-flex zk-items-center zk-justify-center zk-w-full zk-px-4">
			<button
				*ngIf="!saveNewPassword"
				zk-button
				zkButtonColor="secondary"
				type="button"
				(click)="showChangePasswordDialog = false"
			>
				{{ 'MY_ACCOUNT.PERSONAL.CANCEL' | translate }}
			</button>
			<button
				zk-button
				[zkButtonLoading]="saveNewPassword"
				type="button"
				(click)="saveNewPassword = true"
			>
				{{ 'MY_ACCOUNT.PERSONAL.SAVE' | translate }}
			</button>
		</div>
	</ng-container>
</zk-dialog>
